export const isObject = (variable: any) => typeof variable === 'object' && !Array.isArray(variable) && variable !== null
